import "./customdropzone.scss"
import React, {useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import ImportIcon from "../../../modules/icons/import";

type choosedFile = {
    preview: string
}

const CustomDropzone = () => {
    const [files, setFiles] = useState<choosedFile[]>([]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        }
    });

    const thumbs = files.map((file, index) => (
        <div className="Custom-Drop-Zone-Preview" key={index}>
            <img
                className="img-fluid img-thumbnail"
                src={file.preview}
                alt={"selected"}
                onLoad={() => {
                    URL.revokeObjectURL(file.preview)
                }}
            />
        </div>
    ));

    useEffect(() => {
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    return (
        <div className="Custom-Drop-Zone">
            <div className="Custom-Drop-Zone-Top">
                <div {...getRootProps({className: 'dropzone Custom-Drop-Zone-Box'})}>
                    <input {...getInputProps()} multiple={false}/>
                    {
                        isDragActive ? <span>فایل را رها کنید</span> :
                            <>
                                <ImportIcon/>
                                <span className="pe-2">
                                    فایل را بکشید و رها کنید یا
                                    <span style={{color: '#0B62D5', cursor: 'pointer'}}> انتخاب کنید </span>
                                </span>
                            </>
                    }
                </div>
            </div>
            {thumbs}
        </div>
    );
}

export default CustomDropzone